import React, { Component } from "react";
import Table from "../common/table";
import { Link } from "react-router-dom";
import "./list_users.css";
import { Container } from "reactstrap";
import * as ROUTES from "../../constants/routes";

class UsersTable extends Component {
  userDetailsPop = () => {
    alert("asdasas");
    return (
      <React.Fragment>
        <div className="modal" tabindex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Modal title</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Modal body text goes here.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  columns = [
    {
      path: "CompanyName",
      label: "Company",
      content: customer => (
        <Link
          to={{
            pathname: ROUTES.USER_DETAILS,
            state: { modal: true, selectedCustomer: customer }
          }}
          className="link"
        >
          {customer.CompanyName}
        </Link>
        // <Link to={`/user_details/${customer.uid}`}>{customer.CompanyName}</Link>
        //<Link to={ROUTES.USER_DETAILS}>{customer.CompanyName}</Link>
      )
    },
    { path: "creditDays", label: "Credit Days" },
    { path: "emailId", label: "EMail" },
    { path: "gstin", label: "GST #" },
    { path: "mobile", label: "Contact #" },
    {
      path: "ownerName",
      label: "Owner"
    }
  ];
  render() {
    const { customers } = this.props;
    return (
      <Container className="user_table">
        <Table columns={this.columns} data={customers} />
      </Container>
    );
  }
}

export default UsersTable;
